module.exports = __webpack_public_path__ + "img/emoji_82.1c804657.png";